let mobileMenu = document.querySelector('.mobile-menu')
let openMenu = document.querySelector('.open-menu')
let closeMenu = document.querySelector('.close-menu')

if(mobileMenu) {
    window.addEventListener('load', () => {
        mobileMenu.classList.add('ready')
    })
    
    if(openMenu) {
        openMenu.addEventListener('click', () => {
            mobileMenu.classList.add('show')
        })
    }

    if(closeMenu) {
        closeMenu.addEventListener('click', () => {
            mobileMenu.classList.remove('show')
        })
    }

    let hasChildren = mobileMenu.querySelectorAll('.menu-item-has-children')

    if(hasChildren.length) {
        for(let item of hasChildren) {
            let toggler = document.createElement('div')
            let link = item.querySelector('a')
            let list = item.querySelector('ul')

            link.appendChild(toggler)
            toggler.classList.add('arrow')
            toggler.classList.add('icon-down')

            toggler.addEventListener('click', (e) => {
                e.preventDefault()
                list.classList.toggle('show')
            })
        }
    }

    ////

    let openServices = mobileMenu.querySelector('.open-services')
    let closeServices = mobileMenu.querySelector('.close-services')
    let navigationMenu = mobileMenu.querySelector('.navigation')
    let servicesMenu = mobileMenu.querySelector('.services-list')

    openServices.addEventListener('click', () => {
        navigationMenu.classList.remove('show')
        servicesMenu.classList.add('show')
    })

    closeServices.addEventListener('click', () => {
        navigationMenu.classList.add('show')
        servicesMenu.classList.remove('show')
    })
}

function checkHeader() {
    let header = document.querySelector('.site-header')
    let scroll = window.pageYOffset

    if(scroll) {
        header.classList.add('scroll')
    } else {
        header.classList.remove('scroll')
    }

}

window.addEventListener('scroll', checkHeader)
checkHeader()